export default "__VITE_ASSET__D9b0DcAk__"